import React, { useState, useEffect } from 'react';
import { Button, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faFilter } from '@fortawesome/free-solid-svg-icons';
import { useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';

//Constants
import { actionsTable } from '../../../../constants/MaterialTable';

//Context
import { useAuth } from '../../../../context/auth';

//Components
import TabelaListagem from '../../../../components/TabelaListagem/TabelaListagem';

//Api
import requerimento_api from '../../../../api/requerimento';
import tipoRequerimento_api from '../../../../api/tipoRequerimento_api';

//Helpers
import { showMessage } from '../../../../helpers/message';
import { validarCampos, objCampo } from '../../../../helpers/ValidadorDeCampos';

//Shared 
import FichaRequerimento from '../../../Shared/FichaRequerimento';
import TextField from '../../../../components/TextField';

function initialStateFiltros() {
    return {
        status: "Em Andamento",
        tipoRequerimento_Id: null,
        etapa_Id: null,
        dataInicial: null,
        dataFinal: null,
        numeroProcesso: "",
        logradouro: "",
        bairro: "",
        numero: "",
        nomeRequerente: ""
    }
}
export default function Requerimentos({ permissoes }) {
    const { setLoading } = useAuth();

    //Variavel de controle de edição da tela
    const editavel = permissoes.filter(permissao => permissao.acao == "Editar").length > 0;

    //Estado de controle do requerimento selecionado
    const [requerimentoId, setRequerimentoId] = useState(null);

    //Campos obrigatorios dos filtros
    const [campos, setCampos] = useState([
        objCampo({ name: "status", required: true }),
    ]);

    //Estado de controle dos erros
    const [errors, setErrors] = useState({});

    //Estado de controle dos filtros da tela
    const [filtros, setFiltros] = useState(initialStateFiltros);

    //Estado de controle dos tipos de requerimento
    const [tiposRequerimento, setTiposRequerimento] = useState([]);

    //Estado de controle das opções do campo de etapa
    const [etapas, setEtapas] = useState([]);

    //Estado de controle de visibilidade dos filtros
    const [visibleFilters, setVisibleFilters] = useState(false);
    const toggleFilters = () => setVisibleFilters(!visibleFilters);

    //Estado de controle da lista de requerimentos
    const [requerimentos, setRequerimentos] = useState([]);

    //Estado de navegação
    const navigate = useNavigate();

    //Estado que pega os dados passados via navegação
    const location = useLocation();

    //pegando a etapa selecionada no dashboard
    const { etapa, etapaId, btnVoltar } = location.state ? location.state : {};

    //Função do botão visualizar da lista
    const editar = (row) => {
        setRequerimentoId(row.id);
    };

    //Ações que a tabela terá
    const actions = [actionsTable.visualizar(editar)];


    //Cabeçalhos que a tabela terá
    const headers = [
        { value: "Requerente", objectValue: "requerente", align: "left" },
        { value: "Número do Requerimento", objectValue: "numeroRequerimento", align: "left" },
        { value: "Endereço", objectValue: "endereco", align: "left" },
        ...!etapaId
            ?
            [
                { value: "Status", objectValue: "situacao", align: "left" },
                { value: "Etapa", objectValue: "etapa", align: "left" }
            ]   
            : [],
        {
            value: "Prazo", objectValue: "prazoRequerimento", align: "left", options: {
                filter: false,
                customBodyRenderLite: (dataIndex) => {
                    return (
                        <div className={` d-flex align-items-center justify-content-center`}>
                            <span style={{ width: "10px", height: "10px" }} className={`bg-${requerimentos[dataIndex].semaforo == "Verde" ? "success" : requerimentos[dataIndex].semaforo == "Amarelo" ? "warning" : "danger"} rounded-circle`}></span>
                            <span className='ms-2'>{requerimentos[dataIndex]?.prazoRequerimento}</span>
                        </div>
                    )
                }
            }
        },
    ]

    //Função que carrega os requerimentos
    const loadRequerimentos = () => {
        const _errors = validarCampos(filtros, campos);
        setErrors(_errors[0]);

        if (filtros.status != "Em Andamento" && (new Date(filtros.dataInicial)) > (new Date(filtros.dataFinal))) {
            _errors[0].dataInicial = { message: "" };
            _errors[1].push(objCampo({ name: "dataInicial", required: true }));
        }

        if (_errors[1].length > 0)
            return;

        setLoading(true);
        requerimento_api.getList(etapaId ? { etapa_Id: etapaId } : filtros).then(response => {
            response.data = response.data.map(value => {
                if (value.prazoRequerimento) {
                    value.prazoRequerimento = moment(value.prazoRequerimento).format("DD/MM/YYYY");
                } else {
                    value.prazoRequerimento = "Sem prazo"
                }
                return value;
            });
            setRequerimentos(response.data);
        }).catch(e => showMessage('Erro', e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função que carrega os tipos de requerimento
    const loadTiposRequerimento = () => {
        setLoading(true);
        tipoRequerimento_api.getList().then(response => {
            response.data = response.data.map(value => ({ value: value.id, label: value.identificacao }));
            setTiposRequerimento(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função que carrega a lista de etapas
    const loadEtapas = (tipoRequerimentoId) => {
        setLoading(true);
        tipoRequerimento_api.getListEtapas(tipoRequerimentoId).then(response => {
            response.data = response.data.map(value => ({ value: value.id, label: value.identificacao }));
            setEtapas(response.data);
        }).catch(e => showMessage("Erro", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função de onchange dos filtros
    const onChangeFiltros = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        });
    }
    const onChangeStatus = (e) => {
        const { name, value } = e.target;
        setFiltros({
            ...filtros,
            [name]: value
        });
        if (value != "Em Andamento") {
            setCampos([
                ...campos,
                objCampo({ name: "dataInicial", required: true }),
                objCampo({ name: "dataFinal", required: true })
            ]);
        } else {
            setCampos(campos.filter(value => value.name == "dataInicial" || value.name == "dataFinal"));
        }
    }

    //Função de onchange dos filtros searchable
    const onChangeSearchable = (value, e) => {
        setFiltros({
            ...filtros,
            [e.name]: value ? value.value : null,
        });

    }

    const onChangeTipoRequerimento = (value, e) => {
        setFiltros({
            ...filtros,
            [e.name]: value ? value.value : null,
        });
        if (value) {
            loadEtapas(value.value);
        }
    }

    useEffect(() => {
        loadRequerimentos();
        loadTiposRequerimento();
    }, []);

    if (requerimentoId)
        return (
            <FichaRequerimento requerimentoId={requerimentoId} btnVoltar={() => setRequerimentoId(null)} editavel={editavel} />
        )
    return (
        <div>
            {btnVoltar &&
                <Button className='mb-4' onClick={() => navigate(btnVoltar)}>
                    <FontAwesomeIcon className='me-2' icon={faAngleLeft} />
                    VOLTAR
                </Button>
            }
            <div className='d-flex align-items-center justify-content-between mb-4'>
                <h4 className='text-secondary m-0'>{etapa ? etapa : "Requerimentos"}</h4>
                {
                    !etapa &&
                    <Button color='primary' onClick={toggleFilters}><FontAwesomeIcon icon={faFilter} /> Filtros</Button>
                }
            </div >
            <Row className={`filtros ${visibleFilters ? "" : "close"}`}>
                <Col md="12" lg="4">
                    <TextField
                        name={"status"}
                        label={"Status"}
                        type={"select"}
                        options={[
                            { value: "Em Andamento", label: "Em Andamento" },
                            { value: "Finalizado", label: "Finalizado" }
                        ]}
                        onChange={onChangeStatus}
                        value={filtros.status}
                    />
                </Col>
                <Col md="12" lg="4">
                    <TextField
                        name={"dataInicial"}
                        label={`${filtros.status == "Em Andamento" ? "" : "*"} Data inicial`}
                        type={"date"}
                        onChange={onChangeFiltros}
                        value={filtros.dataInicial}
                        invalid={!!errors.dataInicial}
                    />
                </Col>
                <Col md="12" lg="4">
                    <TextField
                        name={"dataFinal"}
                        label={`${filtros.status == "Em Andamento" ? "" : "*"} Data final`}
                        type={"date"}
                        onChange={onChangeFiltros}
                        value={filtros.dataFinal}
                        invalid={!!errors.dataFinal}
                    />
                </Col>
                <Col md="12" lg="6">
                    <TextField
                        name={"tipoRequerimento_Id"}
                        label={"Tipo de requerimento"}
                        type={"select"}
                        searchable
                        onChange={onChangeTipoRequerimento}
                        options={tiposRequerimento}
                        value={tiposRequerimento.filter(v => v.value == filtros.tipoRequerimento_Id)}
                    />
                </Col>
                <Col md="12" lg="6">
                    <TextField
                        name={"etapa_Id"}
                        label={"Etapa"}
                        type={"select"}
                        searchable
                        onChange={onChangeSearchable}
                        options={etapas}
                        value={etapas.filter(v => v.value == filtros.etapa_Id)}
                    />
                </Col>
                <Col md="12" lg="7">
                    <TextField
                        name={"nomeRequerente"}
                        label={"Nome do requerente"}
                        onChange={onChangeFiltros}
                        value={filtros.nomeRequerente}
                    />
                </Col>
                <Col md="12" lg="5">
                    <TextField
                        name={"numeroProcesso"}
                        label={"Número do processo"}
                        onChange={onChangeFiltros}
                        value={filtros.numeroProcesso}
                    />
                </Col>
                <Col md="12" lg="6">
                    <TextField
                        name={"logradouro"}
                        label={"Logradouro"}
                        onChange={onChangeFiltros}
                        value={filtros.logradouro}
                    />
                </Col>
                <Col md="12" lg="4">
                    <TextField
                        name={"bairro"}
                        label={"Bairro"}
                        onChange={onChangeFiltros}
                        value={filtros.bairro}
                    />
                </Col>
                <Col md="12" lg="2">
                    <TextField
                        name={"numero"}
                        label={"Número"}
                        onChange={onChangeFiltros}
                        value={filtros.numero}
                    />
                </Col>

                <Col md="12" lg="12" className='d-flex align-items-center justify-content-center mb-4'>
                    <Button color='primary' onClick={loadRequerimentos}><FontAwesomeIcon icon={faFilter} /> Filtrar</Button>
                </Col>
            </Row>
            <TabelaListagem
                actions={actions}
                title={"Lista de requerimentos"}
                options={{ print: false, search: true, pagination: true }}
                headers={headers}
                items={requerimentos}
            />
        </div>
    )
}